export const features = {
    "template": "template2",
    "companyName": "Co-operative Insurance Companies (Prod)",
    "inowEndpoint": "https://coic.iscs.com",
    "tokenIssuer": "https://coic-inow.okta.com/oauth2/default",
    "clientId": "0oa4hrpa72n5ZMDa2697",
    "features": {
        "CustomContentPage1": false,
        "CustomContentPage2": false,
        "addRegistrationEmail": false,
        "agentEmail": false,
        "agentLink": false,
        "agentPanel": true,
        "blockAchNumberOps": true,
        "changeCoverage": false,
        "claimDetailsDocuments": false,
        "claimDetailsPayments": false,
        "claimDocumentUpload": false,
        "claimList": true,
        "claimStatus": true,
        "combinePolicies": true,
        "coverageDetails": true,
        "cpPortalLinking": false,
        "customPrivacyStatement": false,
        "customTOS": false,
        "deactivateUserOnly": false,
        "defaultLossDateTime": false,
        "desktopDeliveryPreferencesDefaultExpanded": true,
        "editPayPlan": false,
        "hasOpenBalance": true,
        "loginPanelExpirationDate": "2999-01-01",
        "mfaEnabled": true,
        "mobileDeliveryPreferencesDefaultExpanded": false,
        "needHelp": true,
        "notificationPreferences": false,
        "otherPaymentAmountAllowed": true,
        "paperlessChoiceUpdate": false,
        "passwordResetInfo": true,
        "payPlanTypesToFilter": [
            "Mortgagee",
            "Agent",
            "Statement"
        ],
        "pendingOrScheduledPaymentsList": true,
        "policyDetailsAddressTypeCd": [],
        "policyDetailsAddress": true,
        "policyDocumentUpload": false,
        "policyForms": false,
        "policyFormsDownload": false,
        "policyUserAttachmentsDisplay": false,
        "printButtonEnabled": true,
        "recentPaymentsList": true,
        "rememberMe": true,
        "reportClaim": false,
        "scheduledPayments": false,
        "showImageTag": true,
        "standardPhoneLength": false,
        "unauthenticatedPayments": true,
        "unauthenticatedReportClaim": false,
        "useInsuredAttachments": false,
        "verifyAddress": true,
        "viewChangeRequests": false
    },
    "keys": {
        "googleAnalytics": "",
        "googleAnalytics4": "G-38J6S4R7H1",
        "googlePlacesApi": ""
    },
    "salesPortalUrl": "https://coic-prod-cp.xi-1-us-west-2.guidewire.net",
    "cpProducts": [
        "Homeowners",
        "Personal Auto"
    ],
    "paymentApiUrl": "https://midas.api.omega2-andromeda.guidewire.net",
    "paymentTenantName": "tenant.coic",
    "paymentConfigIds": {
        "CIUI": "3104701"
    },
    "paymentMethods": [
        "ACH",
        "CC"
    ],
    "anonymousPaymentMethods": [
        "ACH",
        "CC"
    ],
    "achEntryClassCode": "WEB",
    "processingFee": 0,
    "maxUploadFileSize": "500mb",
    "attachmentTemplatesLimit": "20",
    "policiesCountLimit": "50",
    "billingAccountsCountLimit": "50",
    "faviconFileExtension": "ico",
    "policyCreatedSinceDt": 365,
    "policyStatusCd": "Active,Non-Renew Requested",
    "passwordConstraints": [
        {
            "constraint": "minLength",
            "value": 12,
            "message": "Use at least 12 characters"
        },
        {
            "constraint": "minNumber",
            "value": 1,
            "message": "Contain at least one number"
        },
        {
            "constraint": "minLowerCase",
            "value": 1,
            "message": "Contain at least one lower case letter"
        },
        {
            "constraint": "minUpperCase",
            "value": 1,
            "message": "Contain at least one upper case letter"
        }
    ],
    "userIdConstraints": [
        {
            "constraint": "minLength",
            "value": 3,
            "message": "Use at least 3 characters"
        }
    ],
    "downTime": {
        "beginTime": "2025-04-11T16:55-04:00",
        "endTime": "2025-04-12T8:45-04:00",
        "title": "System Down for Maintenance",
        "body": "<p>The Consumer Portal is currently unavailable while we perform maintenance. Access to the Consumer Portal will be available by 8:30am Monday April 14, 2025. Thank you for your patience while we make improvements. We apologize for any inconvenience.</p>"
    },
    "notificationSmsNumber": "123-456-7890",
    "billingStatusCd": "Normal, Legal",
    "apiResponseSizeLimit": 100,
    "_meta": {
        "build": "4.0.0-26-eaf4f61",
        "commit": "eaf4f6179d0bacd80d6ab7d999556bc2362c9c70",
        "company": "coic",
        "date": "2025-05-06T19:20:05+00:00",
        "source": "serviceportal-four-config",
        "version": "4.0.0",
        "imageTag": ""
    },
    "paymentSdkUrl": "https://js-sdk-prod.payments.guidewire.net/v1/gw-payments-sdk.js"
};